import React, { useState,memo} from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';

const TreeSelect = memo(({ data, onSelect,selected }) => {
  //alert(selected);

  const [selectedNodes, setSelectedNodes] = useState([{"value": selected,"checked":true }]);

  const handleSelect = (currentNode, selectedNodes) => {

    setSelectedNodes(selectedNodes);
    onSelect(currentNode);
  };

  return (
    <DropdownTreeSelect
    data={data}
    onChange={handleSelect}
    mode="radioSelect"
    showDropdown
    clearSearchOnChange
    keepTreeOnSearch
    texts={{ placeholder: '--Select --' }}
    selected={selectedNodes}
  />

  
  
  
  
  );
});

export default TreeSelect;
